import t from "babel-plugin-yate/macro";
import pickBy from "lodash-es/pickBy";

const types = {
  "consumer-finance": {
    type: 4,
    pos: 1,
    urlPath: "consumer-finance",
    name: t`Consumer Finance`,
    shortName: "CF",
    isVisible: true,
    slug: 'goods',
  },
  "personal-needs": {
    type: 5,
    pos: 2,
    urlPath: "personal-needs",
    name: t`Personal Needs`,
    shortName: "PN",
    isVisible: true,
    slug: 'pnl',
  },
  "credit-cards": {
    type: 6,
    pos: 3,
    urlPath: "credit-cards",
    name: t`Carduri de credit`,
    shortName: "CC",
    isVisible: true,
    slug: 'credit-card',
  },
  "revolving-transactions": {
    type: 1001,
    pos: 4,
    urlPath: "revolving-transactions",
    name: t`Tranzactii revolving`,
    shortName: "RT",
    isVisible: true,
    slug: 'transactions',
  },
};

export const typesById = {
  4: types['consumer-finance'],
  5: types['personal-needs'],
  6: types['credit-cards'],
  1001: types['revolving-transactions'],
};

export function filteredLendingTypes(user) {
  return pickBy(types, (value) => (
    user?.credit_type?.includes(value.type)
  ));
}

export default types;
